import React from 'react';

import { Dialog, DialogContent } from '@mui/material';
import { DialogHeading } from 'components/dialog-title';
import { ClinicalMeetingActivities } from 'components/clinical-meeting-activities';
import style from './index.module.scss';
import { useTranslate } from 'hooks/use-translate';

import { ignoreEscapeKeyDown } from 'utils/handlers';

const defaultRefresh = () => {};

interface Props {
  clinicalMeetingID: string;
  onClose: () => void;
  onRefresh?: () => void;
}

export const ClinicalMeetingActivitiesDialog: React.FC<React.PropsWithChildren<Props>> = ({
  clinicalMeetingID,
  onClose,
  onRefresh = defaultRefresh,
}) => {
  const { t } = useTranslate();

  return (
    <Dialog
      open={true}
      onClose={ignoreEscapeKeyDown(onClose)}
      fullWidth
      maxWidth="xl"
      classes={{
        paper: style.paper,
      }}
    >
      <DialogHeading title={t('activities')} onClose={onClose} />
      <DialogContent className={style.content}>
        <ClinicalMeetingActivities
          className={style.grid}
          clinicalMeetingID={clinicalMeetingID}
          onRefresh={onRefresh}
        />
      </DialogContent>
    </Dialog>
  );
};
